<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';

const props = defineProps({
  inboxId: {
    type: [String, Number],
    default: 0,
  },
});

const router = useRouter();
const { accountId } = useAccount();
const getInbox = useMapGetter('inboxes/getInbox');

const inbox = computed(() => {
  if (!props.inboxId) return null;
  return getInbox.value(Number(props.inboxId));
});

const connectionStatus = computed(() => inbox.value?.connection_status);

const isDisconnected = computed(
  () => connectionStatus.value?.status === 'disconnected'
);
const isWarning = computed(() => connectionStatus.value?.status === 'warning');

const showBanner = computed(() => isDisconnected.value || isWarning.value);

const bannerMessage = computed(() => connectionStatus.value?.message || '');

const goToSettings = () => {
  router.push({
    name: 'settings_inbox_show',
    params: { accountId: accountId.value, inboxId: props.inboxId },
  });
};
</script>

<template>
  <div
    v-if="showBanner"
    class="flex items-center gap-2 px-3 py-2 text-xs font-medium"
    :class="
      isDisconnected
        ? 'bg-n-ruby-3 text-n-ruby-11 border-b border-n-ruby-6'
        : 'bg-n-amber-3 text-n-amber-11 border-b border-n-amber-6'
    "
  >
    <span class="i-lucide-alert-triangle size-3.5 flex-shrink-0" />
    <span class="flex-1 truncate">{{ bannerMessage }}</span>
    <button
      class="flex-shrink-0 underline underline-offset-2 hover:opacity-70 transition-opacity"
      @click="goToSettings"
    >
      {{ $t('INBOX.DISCONNECT_BANNER.SETTINGS') }}
    </button>
  </div>
</template>
